var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loader',{ref:"loading",attrs:{"object":_vm.secondary,"color1":_vm.primary,"color2":_vm.secondary,"size":"2","speed":"2","bg":"#ffffff","objectbg":"#008744","opacity":"80","disableScrolling":"false","name":"circular"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }